var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNpo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.608 52.267c2-3.867 20.8-28.667 6.133-39.067-6.666-4.667-16.933-1.467-16.4 8.267 0 .666 0 3.333.267 3.866C46.875.8 12.208 35.6 70.608 52.267z",
    fill: "#FF794F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.141 25.333l8.133-.133M24.341 11.6a26.876 26.876 0 019.734 6.8M36.341 4.4l3.2 8.267M31.541 69.733C49.941 62 70.074 74.267 67.408 64c-2.133-8.267-18-6.933-24.267-8.133-10.267-2-20.8-6.934-29.733.266-5.6 4.534-8.667 12-7.733 19.2",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.675 63.733s6.133-1.6 10.666-6.8c2.4-2.8 5.467-6.933 9.867-6.533 1.867.133 3.333 1.2 2.667 3.2-2.667 9.2-26.4 35.2-53.2 27.2-6.667-2-20.8-1.6-18.134 10.667",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgNpo;